import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../../components/navigation/NavBar"
import Footer from "../../components/footer/Footer"
import KundendienstContent from "../../components/Kundendienst/KundendienstContent"
import nextI18NextConfig from "../../next-i18next.config.js"
import {useTranslation} from "next-i18next"
import MbpHead from "../../components/head/MbpHead"
import PropTypes from "prop-types"
import {getPageData} from "../../pageData"

const Kundendienst = () => {
	const {t} = useTranslation()
	const title = t("Kundendienst - MyBikePlan")
	const description = t("Kundendienst Wie können wir dir helfen? Hast Du Fragen oder Probleme mit Deinem E-Bike? Schreibe uns hier direkt und wir werden das Problem so schnell wie möglich lösen.")

	return (
		<>
			<MbpHead>
				<title>
					{title}
				</title>
				<meta name="description"
					content={description}/>
				<meta property="og:title"
					content={title}/>
				<meta property="og:description"
					content={description}/>
			</MbpHead>
			<NavBar/>
			<main>
				<KundendienstContent/>
			</main>
			<Footer/>
		</>
	)
}

Kundendienst.propTypes = {
	bikesList: PropTypes.array
}

export async function getStaticProps({locale}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			...(await serverSideTranslations(locale, ["common", "kundendienst", "URL", "search", "filters"], nextI18NextConfig))
		}
	}
}

export default Kundendienst
